export enum ClaimGuiltyParties {
    DriverOfInsuredVehicle = 1,
    OtherParty = 2,
    NotApplicable = 3
}